import CopyText from "common/CopyText"
import { Table } from "common/Table/Table"
import { Tooltip } from "common/Tooltip"
import { exportToCSV, formatDate } from "utils/funcs"

export const AdStats = ({ data }) => {
  const rows = Array.isArray(data) ? data : []

  const columns = [
    {
      key: "adid",
      dbColName: "_id",
      title: "AD ID",
      render: (adid) => {
        const s = adid != null ? String(adid) : ""
        return <CopyText text={s.length > 9 ? `${s.slice(0, 9)}...` : s || "—"} copyText={s} />
      },
    },
    { key: "badge_id", dbColName: "badge_id", title: "badge id" },
    { key: "first_name", dbColName: "first_name", title: "first name" },
    { key: "last_name", dbColName: "last_name", title: "last name" },
    { key: "ad_amount", dbColName: "ad_amount", title: "Total Cost" },
    { key: "ad_spend", dbColName: "ad_spend", title: "ad spend" },
    { key: "profit", dbColName: "profit", title: "profit" },
    { key: "created_at", dbColName: "createdAt", title: "Created at", render: date => formatDate(date) },
    { key: "who", dbColName: "whoIsPayingForAd", title: "who is paying for ad"},
    { key: "split", dbColName: "splitBetween", title: "Split Between", render: (split) => split?.length > 0 ? split?.map(s => s.name).join(", ") : '' },
    {
      key: "notes",
      dbColName: "notes",
      title: "notes",
      render: (notes) => (
        <Tooltip message={notes}>
          {notes && notes?.toString()?.slice(0, 40)}
        </Tooltip>
      ),
    },
    {
      key: "total_applicants_count",
      dbColName: "total_applicants_count",
      title: "total applicants count",
    },
    {
      key: "total_attendees_count",
      dbColName: "total_attendees_count",
      title: "total attendees count",
    },
    {
      key: "total_rsvp_count",
      dbColName: "total_rsvp_count",
      title: "total rsvp count",
    },
    {
      key: "total_training_count",
      dbColName: "total_training_count",
      title: "total training count",
    },
  ]

  const handleExport = () => {
    exportToCSV(rows, "adsstats")
  }

  return (
    <Table
      columns={columns}
      data={rows}
      handleExport={handleExport}
      totalItems={rows.length}
    />
  )
}
